import { Formik, Form, Field, ErrorMessage } from "formik";
import HeaderDescriptive from "src/components/HeaderDescriptive";
import PageHeader from "src/components/PageHeader";
import FormikField from "src/components/FormikField/FormikField";
import { useLocation, useNavigate } from "react-router-dom";
import { LuUserCog } from "react-icons/lu";
import { useEffect, useState } from "react";
import { get, post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";
import useGetCurrentURL from "src/utils/useGetCurrentURL";
import TwinButton from "src/components/TwinButton";
import { getData } from "src/actions/getData";

export default function EditUser() {

    const [roleOptions, setRoleOptions] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const pathname = useGetCurrentURL();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userId = params.get("id");
    const [user, setUser] = useState()

    useEffect(() => {
        getData((result) => {
            setRoleOptions(result.map(role => {
                return {
                    value: role?.id,
                    label: role?.roleTranslate
                }
            }))
        }, "/roles")
        getData(setUser, `/users/${userId}`)
    }, [])

    return (
        <>
            <PageHeader title="ویرایش کاربر" />
            <Formik
                initialValues={{
                    fullName: user?.fullName,
                    email: user?.email,
                    password: "",
                    roleId: user?.role?.id,
                }}
                enableReinitialize
                onSubmit={async (values, { setSubmitting }) => {
                    setIsLoading(true)
                    const result = await post(`/users/${userId}`, {
                        fullName: values.fullName,
                        email: values.email,
                        password: values.password ? values.password : undefined,
                        roleId: values.roleId,
                    });
                    if (result) {
                        notify("کاربر با موفقیت ویرایش شد")
                        navigate(pathname.slice(0, pathname.search("/edit")));
                    } else {
                        notify("خطایی رخ داده است", "error")
                    }
                    setIsLoading(false)
                }}
            >
                {({ values, errors, touched, setFieldValue }) => (
                    <Form>
                        <div className="flex flex-col bg-white dark:bg-black rounded-2xl p-10 px-20">
                            <HeaderDescriptive
                                title="اطلاعات کاربر"
                                description="اطلاعات زیر را برای ویرایش کاربر تغییر دهید"
                            >
                                <LuUserCog size={40} />
                            </HeaderDescriptive>
                            <div className="flex gap-10 mt-10 ">
                                <div className="flex flex-col xl:grid gap-5 gap-y-9 grid-cols-2  w-full justify-center">
                                    <FormikField
                                        inputName="fullName"
                                        label="نام"
                                        placeholder="نام کامل کاربر را وارد کنید..."
                                        // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="email"
                                        label="ایمیل"
                                        placeholder="ایمیل کاربر را وارد کنید..."
                                        // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="password"
                                        label="گذرواژه"
                                        placeholder="گذرواژه را تنها در صورت نیاز به تغییر وارد کنید..."
                                        // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="roleId"
                                        type="select"
                                        label="سطح دسترسی"
                                        placeholder="سطح دسترسی کاربر را وارد کنید..."
                                        errors={errors}
                                        options={roleOptions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                    />

                                </div>
                            </div>
                            <TwinButton
                                rejectHandle={() => {
                                    navigate(pathname.slice(0, pathname.search("/edit")));
                                }}
                                isLoading={isLoading}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}
